import React from "react";
import RenderSocial from "../components/RenderSocial";

export default function Top({ data }) {

  const getDialNumber = (phone) => {
    if (!phone) return "";
    let cleaned = phone.replace(/\D/g, "");
    if (!cleaned.startsWith("1")) {
      cleaned = "1" + cleaned;
    }

    return `+${cleaned}`;
  };

  return (
    <div className="header-top-bar top-bar-one dark-black-bg">
      <div className="container-fluid">
        <div className="row align-items-center">

          <div className="col-xl-6 col-lg-12 col-md-12">
            <div className="top-bar-left d-flex align-items-center">
              <span className="text">{data?.welcome}</span>
            </div>
          </div>

          <div className="col-xl-6 col-lg-12 col-md-12">
            <div className="top-bar-right">

              {data?.time && (
                <span>
                  {data?.time}

                  {data?.phone && (
                    <a
                      href={`tel:${getDialNumber(data?.phone)}`}
                      className="text"
                    >
                      {data?.phone}   {/* 👈 unchanged display */}
                    </a>
                  )}
                </span>
              )}

              <ul className="social-link">
                {data?.social?.map((item, index) => (
                  <li key={index}>
                    <a href={item.url} target="_blank" title={item.url}>
                      <RenderSocial icon={item.icon} />
                    </a>
                  </li>
                ))}
              </ul>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}